/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_ActivatedInputs */



/**
* | output |
* | --- |
* | "Frost-free mode activated" |
*
* @param {Frost_Free_ActivatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_activated = /** @type {((inputs?: Frost_Free_ActivatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_ActivatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode activated")
	return /** @type {LocalizedString} */ ("Mode HG activé")
});